import React from 'react';
import { QueryCache, MutationCache, QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { removeOldestQuery } from '@tanstack/react-query-persist-client';

const HOUR = 60 * 60 * 1000;

const logger = (error) => console.error('error', error);

export const queryClient = new QueryClient({
  defaultOptions: { queries: { cacheTime: 12 * HOUR, retry: 1 } },
  queryCache: new QueryCache({ onError: logger }),
  mutationCache: new MutationCache({ onError: logger }),
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
  retry: removeOldestQuery,
});

const QueryProvider = ({ children }) => (
  <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
    {children}
  </PersistQueryClientProvider>
);

export default QueryProvider;
